import { __extends } from "tslib";
import { deserializeAws_restJson1_1UpdateCampaignCommand, serializeAws_restJson1_1UpdateCampaignCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateCampaignCommand = /** @class */ (function (_super) {
    __extends(UpdateCampaignCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateCampaignCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateCampaignCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateCampaignCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1UpdateCampaignCommand(input, context);
    };
    UpdateCampaignCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1UpdateCampaignCommand(output, context);
    };
    return UpdateCampaignCommand;
}($Command));
export { UpdateCampaignCommand };
//# sourceMappingURL=UpdateCampaignCommand.js.map